if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          // Keep the gallery position update, but do not scroll the whole page vertically.
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

/* Color gallery: show media belonging to the selected color. */
(() => {
  const normalize = (value) =>
    (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[أإآ]/g, 'ا')
      .replace(/ة/g, 'ه');

  const isColorOption = (name) => {
    const normalized = normalize(name).replace(/\s+/g, '');
    return normalized.includes('color') || normalized.includes('colour') || normalized.includes('لون');
  };

  const getSelectedColor = (variantSelects) => {
    if (!variantSelects) return '';

    const selected = Array.from(
      variantSelects.querySelectorAll('input:checked, select option:checked')
    ).find((element) => {
      const optionName = element.dataset.optionName || element.closest('select')?.name || '';
      return isColorOption(optionName);
    });

    return selected?.value || '';
  };

  const applyColorFilter = (gallery, selectedColor) => {
    if (!gallery) return;

    const mediaItems = Array.from(gallery.querySelectorAll('[data-color-group]'));
    if (!mediaItems.length) return;

    const color = normalize(selectedColor);
    const specificGroups = mediaItems
      .map((item) => normalize(item.dataset.colorGroup))
      .filter((group) => group && group !== 'shared');
    const hasMatchingGroup = color && specificGroups.some((group) => group === color);

    mediaItems.forEach((item) => {
      const group = normalize(item.dataset.colorGroup);
      const visible = !hasMatchingGroup || !group || group === 'shared' || group === color;
      item.hidden = !visible;
      item.setAttribute('aria-hidden', String(!visible));
    });

    const visibleMedia = mediaItems.filter((item) => !item.hidden && item.matches('[data-media-id]'));
    const firstVisible = visibleMedia[0];
    if (!firstVisible || typeof gallery.setActiveMedia !== 'function') return;

    gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
    gallery.dataset.activeColor = color;
  };

  const refreshAllGalleries = () => {
    const variantSelects = document.querySelector('variant-selects');
    const selectedColor = getSelectedColor(variantSelects);
    document.querySelectorAll('media-gallery').forEach((gallery) => {
      applyColorFilter(gallery, selectedColor);
    });
  };

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      window.setTimeout(refreshAllGalleries, 50);
    }
  });

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(refreshAllGalleries, 50);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAllGalleries, { once: true });
  } else {
    refreshAllGalleries();
  }
})();

